export const getOperatingRegionEscalationApi = (params, query) => {
  const queryString = new URLSearchParams(query).toString();
  return `lease/${params?.leaseSlug}/region_escalations${queryString ? `?${queryString}` : ''}`;
};

export const getOperatingRegionEscalationDetailApi = (params) => {
  return `lease/${params?.leaseSlug}/region_escalation`;
};

export const regionfileUploadPostApi = (wrkgSlug) => {
  return `lease/region_escalation/${wrkgSlug}/attachments`;
};

export const addOperatingRegionEscalationApi = (params) => {
  return `lease/${params?.leaseSlug}/region_escalations`;
};

export const editOperatingRegionEscalationApi = (params) => {
  return `lease/${params?.leaseSlug}/region_escalations/${params?.slug}`;
};

export const deleteOperatingRegionEscalationApi = (params) => {
  return `lease/${params?.leaseSlug}/region_escalations`;
};


export const exportOperatingRegionEscalationApi = (leaseId) => {
  return `lease/${leaseId}/region_escalations`;
};

export const regionEscalationfileUploadPostApi = (regionEscalation_slug) => {
    return `/get-pre-signed-url/region_escalation/${regionEscalation_slug}`;
};

export const regionEscalationAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/region_escalation/${attachments_slug}`
}

